// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { IMAEx } from './iMAEx';
export const iMA = 'iMA';
export class IMA extends IMAEx {
    constructor(period, method) {
        super(period, method, 0, PriceType.Close, 0);
    }
    get Name() {
        return iMA;
    }
}
